import React, { useState } from "react";
import ModalContainer from "../../common/modals/modalContainer/ModalContainer";
import Button from "@mui/material/Button";
import { Alert } from "@mui/material";
import Loading from "components/common/loading/Loading";

function ConfirmModal(props) {
  let message = props.op;
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      if (Array.isArray(props.dataRow)) {
        await props.retry(props.dataRow);
      } else {
        await props.retry([props.dataRow]);
      }
    } finally {
      setIsLoading(false);
      props.close();
    }
  };

  const handleClose = () => {
    props.close();
  };

  return (
    <>
      <ModalContainer
        title={`Confirm ${message} action`}
        show={props.show}
        onClose={handleClose}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <>
            <Alert severity="info" style={{ marginBottom: "20px" }}>
              This will resend the HL7 message to the EHR system.
            </Alert>
            <div
              style={{
                display: "inline-flex",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => handleClose()}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                style={{ backgroundColor: "#94ba33", color: "white" }}
                onClick={() => handleConfirm()}
              >
                Confirm
              </Button>
            </div>
          </>
        )}
      </ModalContainer>
    </>
  );
}

export default ConfirmModal;
